import { SeoPage } from 'libs/shared-lib/interfaces';
export const VEHICLE_NOT_AVAILABLE_SEO_FR: SeoPage = {
    title: 'Le véhicule n’a pas été trouvé',
    description: 'Le véhicule n’a pas été trouvé',
    image: '',
    twitter: {
        card: 'summary',
        title: 'Le véhicule n’a pas été trouvé',
        description: 'Le véhicule n’a pas été trouvé',
    },
    og: {
        title: 'Le véhicule n’a pas été trouvé',
        description: 'Le véhicule n’a pas été trouvé',
    },
    robots: {
        noIndex: true,
        noFollow: true,
    },
};
